import { BaseEntityDto } from "@/core/common/entities/base-entity.dto";

export class PlanningBoardDto extends BaseEntityDto {
  businessUnitId: string;
  weekStartDate: string;
  isLocked: boolean;
  comments?: string | null;
}
